var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.293036 0.294193C0.105173 0.486526 0 0.744718 0 1.01358C0 1.28243 0.105173 1.54062 0.293036 1.73296L10.7887 12.5L0.293036 23.2649C0.105173 23.4572 0 23.7154 0 23.9843C0 24.2531 0.105173 24.5113 0.293036 24.7037C0.384351 24.7974 0.493528 24.872 0.614124 24.9229C0.73472 24.9738 0.86429 25 0.995188 25C1.12608 25 1.25566 24.9738 1.37625 24.9229C1.49685 24.872 1.60603 24.7974 1.69734 24.7037L12.8585 13.2517C13.0546 13.0506 13.1643 12.7808 13.1643 12.5C13.1643 12.2192 13.0546 11.9494 12.8585 11.7483L1.69734 0.296347C1.60603 0.202562 1.49685 0.12802 1.37625 0.0771213C1.25566 0.026223 1.12608 0 0.995188 0C0.86429 0 0.73472 0.026223 0.614124 0.0771213C0.493528 0.12802 0.384351 0.202562 0.293036 0.296347V0.294193Z",
    fill: "#393939",
    fillOpacity: 0.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.4dbcd200bfcdcfc73514b9ba259ba80a.svg";
export { ForwardRef as ReactComponent };